import gql from 'graphql-tag';
import { ADDRESS_FRAGMENT } from '../fragments.rest';

export type DeleteAddressMutation = {
  deleteAddress: {
    data: null;
    __typename: 'RestAddress';
  };
};

export const DELETE_ADDRESS_MUTATION = gql`
  mutation DeleteAdressMutation($id: string) {
    deleteAddress(id: $id)
      @rest(type: "RestAddress", endpoint: "user", path: "/addresses/{args.id}", method: "DELETE") {
      data @type(name: "RestAddressData") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
